import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AnnouncementBanner from './components/AnnouncementBanner';
import SnowEffect from './components/SnowEffect';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import CookiePopup from './components/layout/Cookie';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Minecraft from './minecraft/minecraft';
import Novalife from './novalife/novalife';
import Fivem from './fivem/fivem';
import Gmod from './gmod/gmod';
import Discord from './discord/discord';
import Vps from './vps/vps';
import NotFound from './pages/404/404';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <SnowEffect />
        <AnnouncementBanner />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/minecraft" element={<Minecraft />} />
            <Route path="/novalife" element={<Novalife />} />
            <Route path="/fivem" element={<Fivem />} />
            <Route path="/gmod" element={<Gmod />} />
            <Route path="/discord" element={<Discord />} />
            <Route path="/vps" element={<Vps />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookiePopup />
      </div>
    </Router>
  );
};

export default App;
